const AXS = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
      fill="url(#paint0_linear)"
    />
    <path
      d="M3.54234 5.7387C4.02145 5.53908 5.74931 6.42074 6.55335 6.88652C7.20815 7.33433 8.38376 8.15086 8.87844 8.4999C9.37313 8.84895 8.85489 9.12415 8.65466 9.34793C8.45443 9.57172 8.34842 9.63061 8.11286 9.43038C7.8773 9.23015 7.83018 9.15948 7.58284 8.95925C7.3355 8.75902 7.19416 9.01814 6.94682 9.27727C6.69948 9.53639 5.769 10.3726 5.48632 10.7024C5.20364 11.0322 5.05614 10.6907 5.05614 10.3726C5.05614 10.0546 4.97986 9.97218 5.29787 9.63061C5.61588 9.28904 6.18123 8.67658 6.33707 8.4999C6.49291 8.32323 6.55335 8.26731 6.33707 8.15086C6.12079 8.03441 5.85464 7.86806 5.58848 7.73497C5.32231 7.60189 4.85652 7.25254 4.59035 8.41703C4.32418 9.58151 4.74007 12.1766 5.05614 12.7755C5.3713 13.3727 5.71954 13.1428 6.54615 12.5973L6.55335 12.5925C7.38515 12.0436 12.3591 7.36899 13.8729 6.02152C15.3868 4.67404 15.8858 4.24152 16.3683 5.8718C16.8507 7.50207 17.0004 12.1766 16.9172 13.1415C16.834 14.1063 16.884 14.7718 14.9875 13.9899C13.0911 13.208 11.86 12.0768 11.3776 11.7774C10.8952 11.4779 10.7621 11.4946 11.2113 10.9622C11.6604 10.4299 11.8434 10.7793 12.0264 10.8791C12.2094 10.9789 12.8582 11.5778 13.8729 12.1766C14.8877 12.7755 15.237 12.6591 15.4034 11.7774C15.5698 10.8957 15.4533 8.40039 14.9875 7.36899C14.5217 6.33759 13.7399 7.186 9.94697 10.7793C6.15408 14.3725 4.83988 15.2875 4.1911 15.171C3.54231 15.0546 3.3427 12.9918 3.17634 10.7793C3.00999 8.56674 2.94345 5.98823 3.54234 5.7387Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="11.0121"
        y1="-5.56875e-08"
        x2="8.70019"
        y2="20"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0416667" stop-color="#73FBFD" />
        <stop offset="0.28125" stop-color="#43A0F0" />
        <stop offset="1" stop-color="#3459DF" />
      </linearGradient>
    </defs>
  </svg>
);
export default AXS;
